import { entity } from 'simpler-state'


export const profileEntity = entity(null);

export const setProfile = (profile) => {
    profileEntity.set(profile);
}
